module.exports = __webpack_public_path__ + "img/ic_dropdown.1bbd6633.svg";